import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Claim2UserI} from '../../../../../../interfaces/claim.interface';
import { AppService } from '../../../../../../../../app.service';
import { RouterService } from '../../../../../../../../core/services/router.service';
import {
  ActiveUser,
  ExtendedClaim2Customer,
  RelatedCustomer
} from '../../../../../../interfaces/user-data';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent {

  @Input() relatedCustomers: RelatedCustomer[];
  @Input() claims2user: Claim2UserI[];
  @Output() customerAction = new EventEmitter<{action: string, params: any}>();

  constructor(public app: AppService, public router: RouterService) {
  }

  addClaim2User(c: ExtendedClaim2Customer) {
    this.customerAction.emit({action: 'addClaim2User', params: c.external_claim_id});
  }

  sendInvitation(c: ExtendedClaim2Customer) {
    this.customerAction.emit({action: 'sendInvitation', params: c.id});
  }

  getUsrTooltip(users: ActiveUser[]) {
    const counts: {[key: string]: number} = {};
    users.forEach(function(u) { counts[u.email] = (counts[u.email] || 0)+1; });

    let text = '';
    for (let usr in counts) {
      text += `${usr}(${counts[usr].toString()}); `;
    }
    return text;
  }

  editCustomer(id: string) {
    this.router.navigateByUrl('/admin/customers/edit/' + id);
  }

  privateClaim(c: ExtendedClaim2Customer) {
    return c.external_customer_id.includes('@');
  }

  hasPermission(c: ExtendedClaim2Customer) {
    let access2claim = true;
    let limitReached = c.active_users >= c.max_user_count;
    if(this.privateClaim(c)) {
      access2claim = false;
    }
    return access2claim && !limitReached;
  }

}
